











































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import { EntitiesService } from "@/services/api/entities.service";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { UsersService } from "@/services/api/users.service";
import { CurrentUser } from "@/models/auth/current.user";
import { EntityTypeDto, EntityGroupDto } from "@/server/app.dtos";
import { CreateEntityCommand } from "@/server/app.commands";
import SingleFileUploaderComponent from "@/components/uploaders/SingleFileUploader.vue";

@Component({
  components: {
    SingleFileUploader: SingleFileUploaderComponent
  }
})
export default class CreateEntitySideMenuComponent extends BaseSideComponent {
  @Getter("identity") identity!: CurrentUser;
  configsService: ConfigsService = new ConfigsService();
  entitiesService: EntitiesService = new EntitiesService();
  usersService: UsersService = new UsersService();
  entityTypes: EntityTypeDto[] = [];
  entityGroups: EntityGroupDto[] | null = null;
  instance: CreateEntityCommand = new CreateEntityCommand();
  isLoading: boolean = false;
  isValid: boolean = false;

  async created() {
    await this.Load();
  }

  async Load() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;

    // Load App Groups
    await this.configsService.Load("api/EntityGroups", query).then(result => {
      this.entityGroups = result;
    });

    // Load entityTypes
    await this.configsService.Load("api/EntityTypes", query).then(result => {
      this.entityTypes = result;
    });
  }

  async onCreateEntity() {
    if (this.isLoading) return;
    this.isLoading = true;

    await this.entitiesService
      .Create(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/entity/${id}`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }
}
